import * as echarts from 'echarts'
import * as echarts5 from 'echarts5'
import DataService from '@/api/data';
import store from '@/store'
function data() {
    var count
    var onLine
    var percentage
    var data
    var total
    DataService.onLine({
        user_id:store.state.user_id,
        user_token:store.state.token
    }).then(res=>{
        // count = res.data.count;
        // onLine = res.data.onLine;
        // percentage = res.data.percentage;
        // Line()
        data =  [
            { value: res.data.onLine, name: '正常' },
            { value: res.data.fault, name: '故障' },
            { value: res.data.shutDown, name: '停机' },
            { value: res.data.offLine, name: '离线' },
        ]
        total = res.data.totalCount;
        // pie()
    }).catch(err=>{
    })
    // echarts_1();
    // echarts_2();
    // echarts_4();
    // echarts_5();
    // echarts_6();
    function pie(){
        var myChart = echarts5.init(document.getElementById('onLine'));
        var option = {
            tooltip: {
              trigger: 'item'
            },
            title: {
                text: total,
                subtext: '总数',
                x: 'center',
                y: 'center',
                textStyle: {
                    fontWeight: 'normal',
                    fontSize: 16,
                    color: "#fff"
                }
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                textStyle: {
                    color: "#fff"
                },
                left: "80%",
                top: "40%"
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                color: ['#60dda9', '#ff8900', '#c3cbd5', '#f85258'],
                label: {
                    normal: {
                        position: 'inner',
                        formatter: '{c}',
        
                        textStyle: {
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: 14
                        }
                    }
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '40',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data:data
              }
            ]
          };
             // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
    }
    function Line(){
        var myChart = echarts5.init(document.getElementById('onLine'));
        const gaugeData = [
            {
              value: percentage,
              name: '',
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '-20%']
              }
            }
          ];
          var color = percentage>= 90?'#00FF7F':'#F4AC54'
          var option = {
            series: [
              {
                type: 'gauge',
                radius:'80%',
                startAngle: 90,
                endAngle: -270,
                pointer: {
                  show: false
                },
                progress: {
                  show: true,
                  overlap: false,
                  roundCap: true,
                  clip: false,
                  width:'10%',
                  itemStyle: {
                    borderWidth: 1,
                    borderColor:color,
                    color:color
                  }
                },
                axisLine: {
                  lineStyle: {
                    width: 20
                  }
                },
                splitLine: {
                  show: false,
                  distance: 0,
                  length: 10
                },
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: false,
                  distance: 50
                },
                data: gaugeData,
                title: {
                  fontSize: 14
                },
                detail: {
                  width: 50,
                  height: 80,
                  color: '#fff',
                  fontSize:40,
                  rich:{
                      a:{
                          color:"#fff",
                          fontSize:16
                      },
                      b:{
                          fontSize:40,
                          fontFamily:'DINCond-Bold',
                          color:'#fff',
                          lineHeight:40
                      },
                      c:{
                        fontSize:20,
                        fontFamily:'DINCond-Bold',
                        color:'#fff'
                      },
                      d:{
                        fontSize:16,
                        fontFamily:'DINCond-Bold',
                        color:'#FCD045',
                        fontWeight:400
                      },
                      e:{
                        fontSize:16,
                        fontFamily:'DINCond-Bold',
                        color:'#00E7FCFF',
                        fontWeight:400
                      },
                      x:{
                          width:40,
                          height:1,
                          color:'#00D2FF',
                          lineHeight:16
                      }
                  },
                  formatter:[
                      '{a|在线率}',
                      `{b|${percentage}}` + '{c|%}',
                      '{x| ———————}',
                      `{d|${onLine}}` +'{e|/}'+ `{e|${count}}`
                  ].join('\n')
                }
              }
            ]
          };
      
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.addEventListener("resize",function(){
            myChart.resize();
        });
    }
    function echarts_1() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart1'));
    
        let  option = {
      //  backgroundColor: '#00265f',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            backgroundColor:'rgba(50,50,50,0.7)',
            textStyle:{
                color:'#fff'
            }
        },
        grid: {
            left: '0%',
            top:'10px',
            right: '0%',
            bottom: '4%',
           containLabel: true
        },
        xAxis: [{
            type: 'category',
            data: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,.1)",
                    width: 1,
                    type: "solid"
                },
            },
            
            axisTick: {
                show: false,
            },
            axisLabel:  {
                    interval: 0,
                   // rotate:50,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
                },
        }],
        yAxis: [{
            type: 'value',
            axisLabel: {
               //formatter: '{value} %'
                show:true,
                 textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,.1	)",
                    width: 1,
                    type: "solid"
                },
            },
            splitLine: {
                lineStyle: {
                   color: "rgba(255,255,255,.1)",
                }
            }
        }],
        series: [
            {
            type: 'bar',
            data: [200, 300, 300, 900, 1500, 1200, 600],
            barWidth:'20%', //柱子宽度
           // barGap: 1, //柱子之间间距
            itemStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(
                        0, 0, 0, 1,
                        [
                            {offset: 0, color: '#00C0FF'},
                            {offset: 1, color: '#FCFF00'}
                        ]
                    ),
                    opacity: 1,
                    // barBorderRadius: 5,
                }
            }
        }
            
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
    function echarts_2() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart2'));
    
        let option = {
      //  backgroundColor: '#00265f',
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow'},
            backgroundColor:'rgba(50,50,50,0.7)',
            textStyle:{
                color:'#fff'
            }
        },
        grid: {
            left: '0%',
            top:'10px',
            right: '0%',
            bottom: '4%',
           containLabel: true
        },
        xAxis: [{
            type: 'category',
                  data: ['浙江', '上海', '江苏', '广东', '北京', '深圳', '安徽'],
            axisLine: {
                show: true,
             lineStyle: {
                    color: "rgba(255,255,255,.1)",
                    width: 1,
                    type: "solid"
                },
            },
            
            axisTick: {
                show: false,
            },
            axisLabel:  {
                    interval: 0,
                   // rotate:50,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
                },
        }],
        yAxis: [{
            type: 'value',
            axisLabel: {
               //formatter: '{value} %'
                show:true,
                 textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,.1	)",
                    width: 1,
                    type: "solid"
                },
            },
            splitLine: {
                lineStyle: {
                   color: "rgba(255,255,255,.1)",
                }
            }
        }],
        series: [
            {
           
            type: 'bar',
            data: [1500, 1200, 600, 200, 300, 300, 900],
            barWidth:'20%', //柱子宽度
           // barGap: 1, //柱子之间间距
            itemStyle: {
                normal: {
                    color:'#27d08a',
                    opacity: 1,
                    // barBorderRadius: 5,
                }
            }
        }
            
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
    function echarts_5() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart5'));
    
        let option = {
      //  backgroundColor: '#00265f',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            backgroundColor:'rgba(50,50,50,0.7)',
            textStyle:{
                color:'#fff'
            }
        },
        
        grid: {
            left: '0%',
            top:'10px',
            right: '0%',
            bottom: '2%',
           containLabel: true
        },
        xAxis: [{
            type: 'category',
                  data: ['浙江', '上海', '江苏', '广东', '北京', '深圳', '安徽', '四川'],
            axisLine: {
                show: true,
             lineStyle: {
                    color: "rgba(255,255,255,.1)",
                    width: 1,
                    type: "solid"
                },
            },
            
            axisTick: {
                show: false,
            },
            axisLabel:  {
                    interval: 0,
                   // rotate:50,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
                },
        }],
        yAxis: [{
            type: 'value',
            axisLabel: {
               //formatter: '{value} %'
                show:true,
                 textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,.1	)",
                    width: 1,
                    type: "solid"
                },
            },
            splitLine: {
                lineStyle: {
                   color: "rgba(255,255,255,.1)",
                }
            }
        }],
        series: [{
            type: 'bar',
            data: [2, 3, 3, 9, 15, 12, 6, 4, 6, 7, 4, 10],
            barWidth:'20%', //柱子宽度
           // barGap: 1, //柱子之间间距
            itemStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(
                        0, 0, 0, 1,
                        [
                            {offset: 0, color: '#00C0FF'},
                            {offset: 1, color: '#02F3BD'}
                        ]
                    ),
                    opacity: 1,
                    // barBorderRadius: 5,
                }
            }
        }
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
        
    function echarts_4() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart4'));
    
    let  option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                lineStyle: {
                    color: '#dddc6b'
                }
            },
            backgroundColor:'rgba(50,50,50,0.7)',
            textStyle:{
                color:'#fff'
            }
        },
        legend: {
            top:'0%',
            data:['第一','第二'],
            textStyle: {
               color: 'rgba(255,255,255,.5)',
               fontSize:'12',
            }
        },
        grid: {
            left: '10',
            top: '30',
            right: '10',
            bottom: '10',
            containLabel: true
        },
    
        xAxis: [{
            type: 'category',
            boundaryGap: false,
        axisLabel:  {
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize:12,
                    },
                },
            axisLine: {
                lineStyle: { 
                    color: 'rgba(255,255,255,.2)'
                }
    
            },
    
       data: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
    
        }, {
    
            axisPointer: {show: false},
            axisLine: {  show: false},
            position: 'bottom',
            offset: 20,
        }],
    
        yAxis: [{
            type: 'value',
            axisTick: {show: false},
            axisLine: {
                lineStyle: {
                    color: 'rgba(255,255,255,.1)'
                }
            },
           axisLabel:  {
                textStyle: {
                        color: "rgba(255,255,255,.6)",
                    fontSize:12,
                },
            },
    
            splitLine: {
                lineStyle: {
                     color: 'rgba(255,255,255,.1)'
                }
            }
        }],
        series: [
            {
            name: '第一',
            type: 'line',
             smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
                
                normal: {
                    color: '#0184d5',
                    width: 2
                }
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(1, 132, 213, 0.4)'
                    }, {
                        offset: 0.8,
                        color: 'rgba(1, 132, 213, 0.1)'
                    }], false),
                    shadowColor: 'rgba(0, 0, 0, 0.1)',
                }
            },
                itemStyle: {
                normal: {
                    color: '#0184d5',
                    borderColor: 'rgba(221, 220, 107, .1)',
                    borderWidth: 12
                }
            },
            data: [3, 4, 3, 4, 3, 4, 3, 6, 2, 4, 2, 4,3, 4, 3, 4, 3, 4, 3, 6, 2, 4, 2, 4]
        }, 
    {
            name: '第二',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
                
                normal: {
                    color: '#00d887',
                    width: 2
                }
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(0, 216, 135, 0.4)'
                    }, {
                        offset: 0.8,
                        color: 'rgba(0, 216, 135, 0.1)'
                    }], false),
                    shadowColor: 'rgba(0, 0, 0, 0.1)',
                }
            },
                itemStyle: {
                normal: {
                    color: '#00d887',
                    borderColor: 'rgba(221, 220, 107, .1)',
                    borderWidth: 12
                }
            },
            data: [5, 3, 5, 6, 1, 5, 3, 5, 6, 4, 6, 4, 8, 3, 5, 6, 1, 5, 3, 7, 2, 5, 1, 4]
    
        }, 
        
             ]
    
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
    function echarts_6() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart6'));
    
            var dataStyle = {
        normal: {
            label: {
                show: false
            },
            labelLine: {
                show: false
            },
            //shadowBlur: 40,
            //shadowColor: 'rgba(40, 40, 40, 1)',
        }
    };
    var placeHolderStyle = {
        normal: {
            color: 'rgba(255,255,255,.05)',
            label: {show: false,},
            labelLine: {show: false}
        },
        emphasis: {
            color: 'rgba(0,0,0,0)'
        }
    };
    let option = {
        color: ['#0f63d6', '#0f78d6', '#0f8cd6', '#0fa0d6', '#0fb4d6'],
        tooltip: {
            show: true,
            formatter: "{a} : {c} ",
            backgroundColor:'rgba(50,50,50,0.7)',
            textStyle:{
                color:'#fff'
            }
        },
        legend: {
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 12,
            bottom: '3%',
            
            data: ['浙江', '上海', '广东', '北京', '深圳'],
            textStyle: {
                        color: 'rgba(255,255,255,.6)',
                    }
        },
        
        series: [
            {
            name: '浙江',
            type: 'pie',
            clockWise: false,
            center: ['50%', '42%'],
            radius: ['59%', '70%'],
            itemStyle: dataStyle,
            hoverAnimation: false,
            data: [{
                value: 80,
                name: '01'
            }, {
                value: 20,
                name: 'invisible',
                tooltip: {show: false},
                itemStyle: placeHolderStyle
            }]
        },
            {
            name: '上海',
            type: 'pie',
            clockWise: false,
            center: ['50%', '42%'],
            radius: ['49%', '60%'],
            itemStyle: dataStyle,
            hoverAnimation: false,
            data: [{
                value: 70,
                name: '02'
            }, {
                value: 30,
                name: 'invisible',
                tooltip: {show: false},
                itemStyle: placeHolderStyle
            }]
        }, 
            {
            name: '广东',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            center: ['50%', '42%'],
            radius: ['39%', '50%'],
            itemStyle: dataStyle,
            data: [{
                value: 65,
                name: '03'
            }, {
                value: 35,
                name: 'invisible',
                tooltip: {show: false},
                itemStyle: placeHolderStyle
            }]
        },
            {
            name: '北京',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            center: ['50%', '42%'],
            radius: ['29%', '40%'],
            itemStyle: dataStyle,
            data: [{
                value: 60,
                name: '04'
            }, {
                value: 40,
                name: 'invisible',
                tooltip: {show: false},
                itemStyle: placeHolderStyle
            }]
        }, 
            {
            name: '深圳',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            center: ['50%', '42%'],
            radius: ['20%', '30%'],
            itemStyle: dataStyle,
            data: [{
                value: 50,
                name: '05'
            }, {
                value: 50,
                name: 'invisible',
                tooltip: {show: false},
                itemStyle: placeHolderStyle
            }]
        }, ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
    }
export default data;